<template>
	<div class="btn-more">
		<ButtonActionRibbon
			class="btn-more__action-ribbon"
			@click="expanded = !expanded"
			iconClassName="icon-more"
			ref="popperReference"
			variant="icon"
		/>
		<PopperPosition
			trackedRefName="popperReference"
			popoverRefName="popper"
			placement="bottom-end"
			:popperVisible="expanded"
			strategy="fixed"
			:modifiers="popperModifiers"
		/>
		<!-- for DEV, The More Menu will not always display.
			It will only display if there are too many buttons in the action ribbon
			for the space allowed. This can vary between desktop and tablet. -->
		<div class="btn-more__menu-container" ref="popper">
			<MenuMore
				class="btn-more__menu"
				:options="options"
				:visible="expanded"
				@change="onSelectOption"
			/>
		</div>
	</div>
</template>

<script>
import MenuMore from '@/components/forms/menu/menu-more.vue';
import ButtonActionRibbon from '@/components/forms/button/button-action-ribbon.vue';
import PopperPosition from '@/components/visual/popper-position/popper-position.vue';
import buttonMenuMixin from '@/mixins/button-menu-mixin';
import componentPositionMixin from '@/mixins/component-position-mixin';
export default {
	name: 'ButtonActionRibbonMenuMore',
	components: {
		MenuMore,
		ButtonActionRibbon,
		PopperPosition
	},
	mixins: [buttonMenuMixin, componentPositionMixin]
};
</script>

<style lang="scss" scoped>
/* LL styles v1 Only */
.btn-more {
	&:deep(.menu-more) {
		margin-top: 18px;
		margin-right: -16px;
	}
}

/* LL styles v2 Only */
/* .btn-more {
	&:deep(.menu-more) {
		margin-top: 16px;
		margin-right: -16px;
	}
} */
</style>
